<template>
  <div class="bg-white position-relative shadow pb-1" style="min-height: 300px">
    <div class="loader absolute" v-if="loading"></div>
    <div class="d-flex py-3 justify-content-center align-items-center bg-dark text-white">
      <img src="@img/discussion1.svg" alt="">
      <span class="ml-2 fz-16">
        Questions
      </span>
    </div>
    <div class="mt-3 px-3 text-center">
      <template v-if="questions.length">
        <span>Les plus pertinentes</span>
        <div class="fz-12 mt-2 question-list overflow-auto mxh100x4">
          <question-component :question="question" class="mb-3" v-for="(question, indextr) in questions"
                              :key="indextr"/>
        </div>
      </template>
      <span v-else>Aucune question disponible</span>
    </div>
  </div>
</template>

<script>
import QuestionComponent from './MiniQuestion.vue'
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  name: 'QuestionsWidget',
  components: {
    QuestionComponent,
  },
  props: {
    lessonId: {type: Number | String, default: null},
    type: {type: String, default: null},
  },
  data() {
    return {
      questions: [],
      loading: false,
    }
  },
  methods: {
    moment,
    loadData(val) {
      this.loading = true
      this.$store.dispatch('question/fetchRecent').then(({data}) => {
        this.questions = data;
      })
        .finally(() => this.loading = false)
    },
  },
  created() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
.bg-white {
  border-radius: 5px;
}
</style>
